export default "__VITE_ASSET__D5ai3jmv__"